import { GemSalesConfig } from "./types";

export function buildTokenCss(config: GemSalesConfig): string {
  const theme = config.theme;

  return `
    --gem-color-primary: ${theme.primaryColor};
    --gem-color-primary-hover: ${theme.primaryHoverColor};
    --gem-color-primary-tint: ${theme.primaryTintColor};
    --gem-color-surface: ${theme.backgroundColor};
    --gem-color-surface-alt: ${theme.surfaceAltColor};
    --gem-color-text: ${theme.textColor};
    --gem-color-muted: ${theme.mutedTextColor};
    --gem-color-border: ${theme.borderColor};
    --gem-color-border-subdued: ${theme.borderSubduedColor};
    --gem-color-success: ${theme.successColor};
    --gem-color-warning: ${theme.warningColor};
    --gem-color-critical: ${theme.criticalColor};
    --gem-color-info: ${theme.infoColor};
    --gem-radius-sm: ${theme.radiusSm};
    --gem-radius-md: ${theme.radiusMd};
    --gem-radius-lg: ${theme.radiusLg};
    --gem-space-1: 4px;
    --gem-space-2: 8px;
    --gem-space-3: 12px;
    --gem-space-4: 16px;
    --gem-space-5: 20px;
    --gem-space-6: 24px;
    --gem-shadow-sm: ${theme.shadowSm};
    --gem-shadow-md: ${theme.shadowMd};
    --gem-font-body: ${theme.fontBody};
    --gem-font-heading: ${theme.fontHeading};
    --gem-transition-fast: 0.15s ease;
  `;
}

export const GEM_SUITE_UI_NOTES = [
  "Polaris-aligned neutral colors: #202223 text, #6D7175 muted, #E1E3E5 border.",
  "4px spacing scale with 8px default radius for embedded controls.",
  "Compact chips and dense panels; avoid oversized marketing-card treatment.",
  "Use scoped CSS variables so GemStorefront/GemTheme can pass brand tokens.",
] as const;
